import { PlainModal } from '@/components/modals/plain-modal';
import { TextLink } from '@/components/text-link';
import { joinSgcmSite } from '@/utils/url/join/public';

import { vesTableContent } from './configs';
import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const VesModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerVesModal}
    contentClassName={styles.containerVesContent}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      The
      <TextLink
        className={styles.textLink}
        href={`${joinSgcmSite('/articles/news/new-vehicular-emissions-scheme-and-restructured-diesel-taxes-18204')}`}
        target="_blank"
        text=" VES " />
      takes into consideration a vehicle&apos;s emissions of four
      pollutants, namely hydrocarbons (HC), carbon monoxide (CO), nitrogen
      oxides (NOx) and particulate matter (PM), in addition to the
      vehicle&apos;s carbon emissions, to encourage consumers to shift to
      less pollutive models.
    </div>
    <div>
      Cars registered from 1 January 2024 will be assessed based on their
      emissions of HC, CO, NOx), PM and CO2). The VES rebate or surcharge
      will be determined by the worst performing pollutant.
    </div>
    <div className={styles.containerVesTable}>
      <div className={styles.contaerTableWrapper}>
        <table className={styles.containerTable}>
          <thead>
            <tr>
              <th>Band</th>
              <th>CO₂ (g/km)</th>
              <th>HC (g/km)</th>
              <th>CO (g/km)</th>
              <th>NOₓ (g/km)</th>
              <th>PM* (mg/km)</th>
              <th colSpan={2}>Car</th>
            </tr>
            <tr>
              <th aria-hidden="true" />
              <th aria-hidden="true" />
              <th aria-hidden="true" />
              <th aria-hidden="true" />
              <th aria-hidden="true" />
              <th aria-hidden="true" />
              <th>Rebate**</th>
              <th>Surcharge</th>
            </tr>
          </thead>
          <tbody>
            {vesTableContent.map(row => (
              <tr key={`row-${row[0]}`}>
                {row.map(cell => (
                  <td key={`cell-${cell[0]}`}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    <div>
      Cars that fall under bands A1 and A2 will qualify for rebates which
      are offset against the car&apos;s ARF payable. Cars that fall under bands
      C1 and C2 will incur a corresponding registration surcharge.
      Cars are also subject to a minimum ARF payable of S$5,000.
      The minimum ARF payable will ensure that cars continue to enjoy a certain
      amount of Preferential Additional Registration Fee benefit when they are
      deregistered early. This is in line with the existing policy objective
      of encouraging timely deregistration and keeping Singapore car fleet
      young.
    </div>
    <br />
  </PlainModal>
);
